/* eslint-disable no-console */
class DummySatellite {
    constructor(adobeTaggingObj) {
        this.adobeTagging = adobeTaggingObj || window.HELIOS.adobe.tagging;
    }

    getVar = (...args) => {
        console.info('satellite getVar() called with arguments: ', args);
    };

    setVar = (...args) => {
        console.info('satellite setVar() called with arguments: ', args);
    };

    setCookie = (...args) => {
        console.info('It seems you dont have Adobe Analytics plugged in this page (perhaps you are working on local environment).');
        console.info('Using a dummy sattelite so you can monitor analytics calls.');
        console.info('satellite setCookie() called with arguments: ', args);
    };

    track = (...args) => {
        console.info('It seems you dont have Adobe Analytics plugged in this page (perhaps you are working on local environment).');
        console.info('Using a dummy sattelite so you can monitor analytics calls.');
        console.info('satellite track() called with arguments: ', args);
        console.info('satellite track() called for tagging data: ', this.adobeTagging);
    };
}

export default DummySatellite;
